export const fontSizes = {
	xs: "11px",
	sm: "14px",
	md: "18px",
	lg: "24px",
};
